module.exports = __webpack_public_path__ + "static/media/16_negro.2e70d048.svg";